import React, { ReactNode } from 'react';
import { formatNumber } from "../../../../../util/varibles/global";

interface IProps {
    data: {
        fish_amount?: number,
        total_weight?: number,
    }
    keySplit?: string | ReactNode
    fontSize?: number
    showZero?: boolean
}

const InfoFish: React.FC<IProps> = ({ data: { fish_amount = 0, total_weight = 0 } = {}, keySplit = '/', fontSize = 14, showZero = false }) => {
    if (!total_weight && !showZero)
        return null;
    const value: ReactNode[] = [];
    if (fish_amount || showZero) {
        value.push(<span key='fish_amount'>{formatNumber(fish_amount)} fish</span>);
        value.push(<span key='split' className='mx-1'>{keySplit}</span>)
    }
    value.push(<span key='total_weight'>{Math.round(total_weight / 10000) / 100} {showZero && !total_weight ? 'tons' : 'tn'}</span>);

    return <div className={`text-[${fontSize}px] whitespace-nowrap`}>{value}</div>;
};

export default InfoFish;
